module.exports = __webpack_public_path__ + "static/media/Close.5619de23.svg";